export default __webpack_public_path__ + "static/media/ic_cancel.71112095.svg";